import React, { useEffect, useState } from 'react'
import HeaderTitle from '../../../components/HeaderTitle'
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Modal from '../../../components/Modal';
import swal from 'sweetalert';
import { hasMuhasebeRole, isAdmin } from '../../../utils/roleUtils';

function YibfList() {
    let { companyID } = useParams();

    const { token, role } = useSelector((state) => state.auth)

    const canManageYibf = hasMuhasebeRole(role) || isAdmin(role)

    const [yibfList, setYibfList] = useState([])
    const [editingYibf, setEditingYibf] = useState(null)

    const ybifSaveForm = useForm({
        defaultValues: {
            yibf: '',
            numberOfPours: '',
            paid: '1',
            used: 0,
            companyId: Number(companyID)
        }
    });

    const ybifSave = (data) => {
        if (!canManageYibf) {
            swal("Bu işlem için yetkiniz bulunmamaktadır", {
                icon: "error",
            });
            return;
        }

        // Convert paid to boolean (1 = true, 2 = false)
        data.paid = data.paid === '1'

        const createRequestBody = {
            ...data,
            companyId: Number(data.companyId || companyID),
            numberOfPours: Number(data.numberOfPours),
            used: Number(data.used || 0)
        }

        const updateRequestBody = {
            yibfId: Number(editingYibf?.id),
            numberOfPours: Number(data.numberOfPours),
            used: Number(data.used || 0),
            paid: data.paid
        }

        const request = editingYibf?.id
            ? axios.put(`${process.env.REACT_APP_SERVICE_URL}/yibf`, updateRequestBody, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            : axios.post(`${process.env.REACT_APP_SERVICE_URL}/yibf`, createRequestBody, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })

        request
            .then((response) => {
                console.log(response.data)
                swal(editingYibf?.id ? "YBİF başarıyla güncellendi" : "YBİF başarıyla eklendi", {
                    icon: "success",
                });
                closeYbifModal()
            })
            .catch((error) => {
                console.error(error)
                swal(editingYibf?.id ? "YBİF güncellenirken hata oluştu" : "YBİF eklenirken hata oluştu", {
                    icon: "error",
                });
            })
            .finally(() => {
                ybifSaveForm.reset()
                getYibfList()
            })
    }
    const [ybifModal, setYbifModal] = useState({
        isOpen: false,
    });
    const openYbifModal = (id) => {
        setEditingYibf(null)
        setYbifModal({
            isOpen: true,
            id: id
        })
        ybifSaveForm.reset({
            yibf: '',
            numberOfPours: '',
            paid: '1',
            used: 0,
            companyId: Number(id)
        })
    }

    const openEditYbifModal = (yibf) => {
        setEditingYibf(yibf)
        setYbifModal({
            isOpen: true,
            id: yibf.companyId
        })
        ybifSaveForm.reset({
            yibf: yibf.yibf,
            numberOfPours: yibf.numberOfPours,
            paid: yibf.paid ? '1' : '2',
            used: yibf.used,
            companyId: yibf.companyId
        })
    }

    const closeYbifModal = () => {
        setEditingYibf(null)
        setYbifModal({
            isOpen: false,
            id: 0
        })
        ybifSaveForm.reset({
            yibf: '',
            numberOfPours: '',
            paid: '1',
            used: 0,
            companyId: Number(companyID)
        })
    }

    const getYibfList = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/yibf?companyId=${companyID}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                setYibfList(response.data)
            })
            .catch((error) => {
                console.error(error)
                setYibfList([])
            })
    }

    const deleteYibf = (id) => {
        if (!canManageYibf) {
            swal("Bu işlem için yetkiniz bulunmamaktadır", {
                icon: "error",
            });
            return;
        }

        swal({
            title: "Emin misiniz?",
            text: "YBİF silinecek!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    axios.delete(`${process.env.REACT_APP_SERVICE_URL}/yibf/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then((response) => {
                            console.log(response.data)
                            swal("YBİF başarıyla silindi", {
                                icon: "success",
                            });
                            getYibfList()
                        })
                        .catch((error) => {
                            console.error(error)
                            swal("YBİF silinirken hata oluştu", {
                                icon: "error",
                            });
                        })
                }
            });
    }

    useEffect(() => {
        getYibfList()
    }, [])

    return (
        <div className='container-fluid'>
            <HeaderTitle title="Yibf Listesi" description="Yibf Listesi" />

            <div className='row'>
                <div className='col-12'>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='table-responsive mt-3'>
                                <table className='table table-striped'>
                                    <caption className='text-end'>Toplam {yibfList?.totalElements} kayıt bulundu</caption>
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>
                                                <button type='button' title="Yenile" aria-label="Listeyi yenile" className='btn btn-outline-secondary btn-app btn-app--icon' onClick={getYibfList}>
                                                    <i className='bi bi-arrow-clockwise'></i>
                                                </button>
                                            </th>
                                            <th className='text-center'>
                                                {
                                                    yibfList?.content?.length > 0 &&
                                                    <span className='text-muted'>
                                                        {yibfList?.content[0].companyName}
                                                    </span>
                                                }
                                            </th>
                                            <th className='text-end' colSpan={2}>
                                                {canManageYibf && (
                                                    <button type="button" className='btn btn-dark btn-app' title="YİBF ata" onClick={() => openYbifModal(companyID)}>
                                                        <i className='bi bi-plus-lg'></i>
                                                        YİBF ekle
                                                    </button>
                                                )}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th scope='col'>#</th>
                                            <th scope='col'>Yibf</th>
                                            <th scope='col'>Kullanım Limiti</th>
                                            <th scope='col'>Kalan Kullanım</th>
                                            <th scope='col'>İşlemler</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            yibfList?.content?.map((yibf, index) => (
                                                <tr key={yibf.id}>
                                                    <th className='align-middle' scope='row'>{index + 1}</th>
                                                    <td className='align-middle'>{yibf.yibf}</td>
                                                    <td className='align-middle'>{yibf.numberOfPours}</td>
                                                    <td className='align-middle'>
                                                        {
                                                            yibf.numberOfPours - yibf.used
                                                        }
                                                    </td>
                                                    <td className='align-middle'>
                                                        {canManageYibf && (
                                                            <div className='d-inline-flex gap-1'>
                                                                <button onClick={() => openEditYbifModal(yibf)} type='button' title="Düzenle" aria-label="Düzenle" className='btn btn-outline-primary btn-app btn-app--icon'>
                                                                    <i className='bi bi-pencil'></i>
                                                                </button>
                                                                <button onClick={() => deleteYibf(yibf.id)} type='button' title="Sil" aria-label="Sil" className='btn btn-outline-danger btn-app btn-app--icon'>
                                                                    <i className='bi bi-trash'></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal isOpen={ybifModal.isOpen} onRequestClose={closeYbifModal} headerTitle={editingYibf?.id ? 'YİBF Güncelle' : 'YİBF Ata'}>
                <form onSubmit={ybifSaveForm.handleSubmit(ybifSave)}>
                    <input type='hidden' {...ybifSaveForm.register('companyId')} />
                    <div className='row mb-3'>
                        <label className='col-sm-3 col-form-label'>YİBF KODU</label>
                        <div className='col-sm-9'>
                            <input type='text' className='form-control' name='yibf' {...ybifSaveForm.register('yibf')} />
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <label className='col-sm-3 col-form-label'>Kullanım Limiti</label>
                        <div className='col-sm-9'>
                            <input type='number' min={1} className='form-control' name='numberOfPours' {...ybifSaveForm.register('numberOfPours')} />
                        </div>
                    </div>
                    {editingYibf?.id && (
                        <div className='row mb-3'>
                            <label className='col-sm-3 col-form-label'>Kullanılan</label>
                            <div className='col-sm-9'>
                                <input type='number' min={0} className='form-control' name='used' {...ybifSaveForm.register('used')} />
                            </div>
                        </div>
                    )}
                    <div className='row mb-3'>
                        <label className='col-sm-3 col-form-label'>Ödeme</label>
                        <div className='col-sm-9'>
                            <select className='form-control' name='paid' {...ybifSaveForm.register('paid')}>
                                <option value='1'>Yapıldı</option>
                                <option value='2'>Yapılmadı</option>
                            </select>
                        </div>
                    </div>
                    <div className=''>
                        <button type='submit' className='btn btn-dark btn-app btn-app--lg'>{editingYibf?.id ? 'Güncelle' : 'Kaydet'}</button>
                    </div>
                </form>
            </Modal>
        </div>
    )
}

export default YibfList